import { render } from "./newCaisse.vue?vue&type=template&id=52e5da84&scoped=true"
import script from "./newCaisse.vue?vue&type=script&lang=js"
export * from "./newCaisse.vue?vue&type=script&lang=js"

import "./newCaisse.vue?vue&type=style&index=0&id=52e5da84&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5da84"]])

export default __exports__